export default __webpack_public_path__ + "static/media/Literarte-documentation.d935d6a0.md";